import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash-es';
import { Country } from 'src/app/modules/admin/models';
import { CountryService } from 'src/app/modules/admin/services';

@Component({
  standalone: false,
  selector: 'gstar-countries-combobox',
  templateUrl: './countries-combobox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountriesComboboxComponent implements OnInit {
  private countryService = inject(CountryService);
  private translate = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);

  @Input() value!: Country;
  @Input() disabled?: boolean;
  @Input() title: string = this.translate.instant('country.country');
  required = input<boolean>();

  @Output() clearCountry: EventEmitter<Country> = new EventEmitter();
  @Output() selectCountry: EventEmitter<Country> = new EventEmitter();
  public countries: WritableSignal<Country[]> = signal<Country[]>([]);

  ngOnInit(): void {
    this.countryService.get().subscribe((countries: Country[]) => {
      this.countries.set(cloneDeep(countries));

      if (this.value?.countryId) {
        const matchedCountry = countries.find(
          country => country.countryId === this.value.countryId
        );
        if (matchedCountry) {
          this.value = matchedCountry;
        }
      }

      this.cdr.markForCheck();
    });
  }

  clearCountryHandler(): void {
    this.clearCountry.emit();
  }

  selectCountryHandler(country: Country): void {
    this.value = country;
    this.selectCountry.emit(country);
  }
}
